/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'accounts';
const componentName = 'tenant-settings-page-list';
const prefix = `${moduleName}.${componentName}`;

export const dnsVirtualServicesLabel = `${prefix}.dnsVirtualServicesLabel`;

export const ENGLISH = {
    [dnsVirtualServicesLabel]: 'DNS Virtual Services',
};
